import {
  SET_ADVERTISING_CAMPAIGN_DETAILS,
  SET_ADVERTISING_CAMPAIGNS,
  SET_ADVERTISING_FETCHING,
  SET_ANALYTICS_CHART_DATA,
  SET_ASIN_KEYWORD_CHART_DATA,
  SET_CUSTOM_CAMPAIGN_PRODUCTS_DETAILED_DATA,
  SET_CUSTOM_CAMPAIGNS_DETAILED_DATA,
  SET_CUSTOM_CAMPAIGNS_PRODUCTS_DETAILED_DATA,
  SET_USER_CUSTOM_AD_CAMPAIGNS
} from '../saga/advertising';

const initialState = {
  campaigns: [],
  campaignDetails: null,
  fetching: {
    campaigns: false,
    campaignDetails: false,
    customCampaigns: false,
    analyticsChart: false,
    asinKeywordChart: false,
    customCampaignsDetailedData: false,
    customCampaignProductsDetailedData: false
  },
  customCampaigns: null,
  analyticsChartData: {},
  asinKeywordChartData: [],
  customCampaignsDetailedData: {},
  customCampaignsProductsDetailedData: {},
  customCampaignProductsDetailedData: {}
};

export const advertisingSelector = state => state.advertising;

const advertising = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ADVERTISING_CAMPAIGNS: {
      return { ...state, campaigns: payload };
    }
    case SET_ADVERTISING_CAMPAIGN_DETAILS: {
      return { ...state, campaignDetails: payload };
    }
    case SET_USER_CUSTOM_AD_CAMPAIGNS: {
      return { ...state, customCampaigns: payload };
    }
    case SET_ADVERTISING_FETCHING: {
      return { ...state, fetching: { ...state.fetching, ...payload } };
    }
    case SET_ANALYTICS_CHART_DATA: {
      return { ...state, analyticsChartData: payload };
    }
    case SET_ASIN_KEYWORD_CHART_DATA: {
      return { ...state, asinKeywordChartData: payload };
    }
    case SET_CUSTOM_CAMPAIGNS_DETAILED_DATA: {
      return { ...state, customCampaignsDetailedData: payload };
    }
    case SET_CUSTOM_CAMPAIGNS_PRODUCTS_DETAILED_DATA: {
      return { ...state, customCampaignsProductsDetailedData: payload };
    }
    case SET_CUSTOM_CAMPAIGN_PRODUCTS_DETAILED_DATA: {
      return { ...state, customCampaignProductsDetailedData: payload };
    }
    default: {
      return state;
    }
  }
};

export default advertising;
